import React from 'react';
import { graphql, useGqlContext } from '@search/gql-client/src';
import {
    ReportMutation$variables as ReportMutationVariables, ReportMutation$data as ReportMutationResponse
} from './__generated__/ReportMutation.graphql';

const reportMutation = graphql`
  mutation ReportMutation($offerId: ID!, $banReason: BanReasonEnum!, $comment: String!, $userAgent: String!) {
    createClaim(offerId: $offerId, banReason: $banReason, comment: $comment, userAgent: $userAgent) {
        firstError {
            __typename
            ... on BaseError {
                message
            }
            ... on ClaimErrorInvalidReason {
                message
            }
            ... on ClaimErrorInvalidOfferId {
                message
            }
            ... on ClaimErrorNoReason {
                message
            }
            ... on ClaimErrorNoSnitch {
                message
            }
        }
    }
  }
`;

export type ReportMutationProps = Omit<ReportMutationVariables, 'userAgent'>;

export function useReportMutation() {
    const gql = useGqlContext();

    return React.useCallback((props: ReportMutationProps) => {
        const complementedProps: ReportMutationVariables = {
            ...props,
            userAgent: window.navigator.userAgent
        };

        return gql.execute<ReportMutationVariables, ReportMutationResponse>(
            reportMutation,
            {
                ...complementedProps
            }
        )
            .then();
    }, [ gql ]);
}
